export const WINDOW_CREATE = 'WINDOW_CREATE'
export const WINDOW_OPEN = 'WINDOW_OPEN'
export const WINDOW_OPEN_CREATE = 'WINDOW_OPEN_CREATE'
export const WINDOW_ACTIVATE = 'WINDOW_ACTIVATE'
export const WINDOW_CLOSE = 'WINDOW_CLOSE'
export const WINDOW_DATA = 'WINDOW_DATA'

export const TEMPLATE_CREATE = 'TEMPLATE_CREATE'
export const TEMPLATE_OPEN = 'TEMPLATE_OPEN'
export const TEMPLATE_DELETE = 'TEMPLATE_DELETE'
export const TEMPLATE_FOLDER = 'TEMPLATE_FOLDER'
export const TEMPLATE_LAYER = 'TEMPLATE_LAYER'
export const TEMPLATE_NAME = 'TEMPLATE_NAME'
export const TEMPLATE_DATA = 'TEMPLATE_DATA'
export const TEMPLATE_OPTIONS = 'TEMPLATE_OPTIONS'
export const TEMPLATE_OVERLAY_DATA = 'TEMPLATE_OVERLAY_DATA'
export const TEMPLATE_OVERLAY_OPTIONS = 'TEMPLATE_OVERLAY_OPTIONS'

export const ALBUM_CREATE = 'ALBUM_CREATE'
export const ALBUM_OPEN = 'ALBUM_OPEN'
export const ALBUM_DELETE = 'ALBUM_DELETE'
export const ALBUM_META = 'ALBUM_META'
export const ALBUM_PICTURE_CREATE = 'ALBUM_PICTURE_CREATE'
export const ALBUM_PICTURE_CHANGE = 'ALBUM_PICTURE_CHANGE'
export const ALBUM_PICTURE_REMOVE = 'ALBUM_PICTURE_REMOVE'

export const DATASET_CREATE = 'DATASET_CREATE'
export const DATASET_OPEN = 'DATASET_OPEN'
export const DATASET_DELETE = 'DATASET_DELETE'

export const TOGGLE_PLAY_STOP = 'TOGGLE_PLAY_STOP'
export const COMMAND_NEXT = 'COMMAND_NEXT'
export const COMMAND_UPDATE = 'COMMAND_UPDATE'
export const COMMAND_INVOKE = 'COMMAND_INVOKE'
export const OVERLAY_DATA = 'OVERLAY_DATA'
export const OVERLAY_OPTIONS = 'OVERLAY_OPTIONS'
export const CLEAR_CHANNEL = 'CLEAR_CHANNEL'
export const FETCH_ACCOUNTS = 'FETCH_ACCOUNTS'



// WEBPACK FOOTER //
// ./src/store/action-types.js